import { ActiveModes, OccCustomerConsignment } from '@checkout-v2/const';
import { MemoizedSelector, createSelector } from '@ngrx/store';
import { CustomOrder } from '@order/const';
import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import { CustomCheckoutState, StateWithCustomCheckout } from '../checkout-state';
import { getCustomCheckoutState } from './feature.selector';

export const getActiveModes: MemoizedSelector<StateWithCustomCheckout, ActiveModes> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => state?.activeModes || {},
);

export const getApplyingBonus: MemoizedSelector<StateWithCustomCheckout, number> = createSelector(
  getActiveModes,
  (activeModes: ActiveModes) => activeModes.applyingBonus,
);

export const getActivePickup: MemoizedSelector<StateWithCustomCheckout, string | undefined> = createSelector(
  getActiveModes,
  (activeModes: ActiveModes) => activeModes.pickup,
);

export const getOrderDetails: MemoizedSelector<StateWithCustomCheckout, CustomOrder> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => state.orderDetails,
);

export const getUserPickupShopListState: MemoizedSelector<
  StateWithCustomCheckout,
  StateUtils.LoaderState<Pos[]>
> = createSelector(getCustomCheckoutState, (state: CustomCheckoutState) => state.userPickupShopList);

export const getUserPickupShopListValue: MemoizedSelector<StateWithCustomCheckout, Pos[]> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderValueSelector(state.userPickupShopList),
);

export const getUserPickupShopListLoading: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderLoadingSelector(state.userPickupShopList),
);

export const getUserPickupShopListSuccess: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderSuccessSelector(state.userPickupShopList),
);

export const getUserPickupShopListError: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderErrorSelector(state.userPickupShopList),
);

export const getCustomerConsignmentState: MemoizedSelector<
  StateWithCustomCheckout,
  StateUtils.LoaderState<OccCustomerConsignment>
> = createSelector(getCustomCheckoutState, (state: CustomCheckoutState) => state.customerConsignment);

export const getCustomerConsignmentValue: MemoizedSelector<StateWithCustomCheckout, OccCustomerConsignment> =
  createSelector(getCustomerConsignmentState, (state: StateUtils.LoaderState<OccCustomerConsignment>) =>
    StateUtils.loaderValueSelector(state),
  );

export const getCustomerConsignmentLoading: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomerConsignmentState,
  (state: StateUtils.LoaderState<OccCustomerConsignment>) => StateUtils.loaderLoadingSelector(state),
);

export const getCustomerConsignmentError: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomerConsignmentState,
  (state: StateUtils.LoaderState<OccCustomerConsignment>) => StateUtils.loaderErrorSelector(state),
);

export const getCustomerConsignmentSuccess: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomerConsignmentState,
  (state: StateUtils.LoaderState<OccCustomerConsignment>) => StateUtils.loaderSuccessSelector(state),
);
